import React from "react";

import {
  DIRECT_LABOR_FIXED_COLUMNS,
  DIRECT_LABOR_FIXED_TOTAL_WIDTH,
  SUMMARY_LABEL_COLUMN_WIDTH,
  SUMMARY_LABEL_FILLER_WIDTH,
} from "./weeklyEACColumns";
import { WEEKLY_SUMMARY_ROWS, getRowLabel } from "./weeklyEACSummaryRows";

// No header row here — like Detailed View's Margin table, this rolls up right below Direct
// Labor and relies on Direct Labor's header for column meaning. table-layout: fixed + an explicit
// width (matching Direct Labor's fixed-column total) keeps this table pinned to that width
// instead of growing with content, so both tables' scrollable weekly columns start at the same
// offset and line up.
export default function WeeklyEACSummaryFixedTable({ type }) {
  const visibleRows = WEEKLY_SUMMARY_ROWS.filter((row) => row.hideForType !== type);

  return (
    <table
      className="firstTableFin weeklyEac"
      cellPadding={0}
      cellSpacing={0}
      style={{ width: DIRECT_LABOR_FIXED_TOTAL_WIDTH, tableLayout: "fixed" }}
    >
      <tbody>
        {visibleRows.map((row) => (
          <tr key={row.key} className="totalRow">
            <td
              colSpan={DIRECT_LABOR_FIXED_COLUMNS.length}
              style={{
                minWidth: SUMMARY_LABEL_COLUMN_WIDTH,
                maxWidth: SUMMARY_LABEL_COLUMN_WIDTH,
                textAlign: "right",
                paddingRight: "8px",
              }}
              title={getRowLabel(row, type)}
            >
              {getRowLabel(row, type)}
            </td>
            {/* {SUMMARY_LABEL_FILLER_WIDTH > 0 && (
              <td
                colSpan={DIRECT_LABOR_FIXED_COLUMNS.length - 1}
                style={{ minWidth: SUMMARY_LABEL_FILLER_WIDTH }}
              />
            )} */}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
